module.exports = __webpack_public_path__ + "images/918e3d7a6f886a825c3bb26322573e71-travpro_logo.png";